import(/* webpackMode: "eager", webpackExports: ["TimeZoneChangeDetector"] */ "/app/apps/web/src/app/[locale]/timezone-change-detector.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PostHogPageView"] */ "/app/apps/web/src/app/posthog-page-view.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UserProvider"] */ "/app/apps/web/src/components/user-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PreferencesProvider"] */ "/app/apps/web/src/contexts/preferences.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["I18nProvider"] */ "/app/apps/web/src/i18n/client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FeatureFlagsProvider"] */ "/app/apps/web/src/lib/feature-flags/client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LocaleSync"] */ "/app/apps/web/src/lib/locale/client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TimezoneProvider"] */ "/app/apps/web/src/lib/timezone/client/context.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/web/src/style.css");
;
import(/* webpackMode: "eager", webpackExports: ["TRPCProvider"] */ "/app/apps/web/src/trpc/client/provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ConnectedDayjsProvider"] */ "/app/apps/web/src/utils/dayjs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LazyMotion","domAnimation"] */ "/app/node_modules/.pnpm/motion@12.9.2_react-dom@19.2.1_react@19.2.1__react@19.2.1/node_modules/motion/dist/es/motion/lib/react.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next-runtime-env@3.3.0_next@15.5.7_@babel+core@7.28.3_@opentelemetry+api@1.9.0_@playwri_a54c07621803ac7fba635687142162f2/node_modules/next-runtime-env/build/provider/env-provider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next-runtime-env@3.3.0_next@15.5.7_@babel+core@7.28.3_@opentelemetry+api@1.9.0_@playwri_a54c07621803ac7fba635687142162f2/node_modules/next-runtime-env/build/provider/use-env-context.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.5.7_@babel+core@7.28.3_@opentelemetry+api@1.9.0_@playwright+test@1.52.0_react-d_a48038301bb456620b2a1d6303782d1d/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.5.7_@babel+core@7.28.3_@opentelemetry+api@1.9.0_@playwright+test@1.52.0_react-d_a48038301bb456620b2a1d6303782d1d/node_modules/next/font/google/target.css?{\"path\":\"src/app/[locale]/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"swap\"}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager", webpackExports: ["PostHogProvider","PostHogIdentify"] */ "/app/packages/posthog/src/client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/app/packages/ui/src/sonner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TooltipProvider"] */ "/app/packages/ui/src/tooltip.tsx");
